import {Box,Typography} from '@mui/material'

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={12}> {displayText} </Typography>
  }

const ContentView = ({title,content,titleSize,limit})=>{
return (
	<Box sx={{margin:1,color:"gray",textAlign:"left",marginBottom:0}}>
		<Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:titleSize ? titleSize : 13}}>
			{title}
		</Typography>
		<DescriptionText text={content} limit={limit ? limit : 85}/>
	</Box>
)	
}

export default ContentView

